<template>
    <div :class="plays.length > 0 ? 'play-grid-view' : ''" v-if="canView('playbooks')">
        <div v-if="plays.length === 0" class="text-center py-5">
            <h5>No {{ status }} plays found</h5>
            <p>There are no plays to display at the moment.</p>
        </div>
        <div v-else v-for="(play, index) in plays" :key="play.id" class="card " :class="status=='draft' ? 'draft-card' : 'content-card'">
            <div class="content-card-header">
               <h4> <a href="#" class="text-decoration-none" @click.stop="goToPlayBuilder(play)">{{ play.name }}</a></h4>
            </div>
            <div class="content-card-body">
                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="d-flex align-items-start">
                            <div class="btn btn-white btn-icon-only-sm d-flex align-items-center justify-content-center me-2 disabled">
                                <img class="icon" src="/img/icons/avid-icons/calendar.svg" style="width: 16px; height: 16px;" alt="" />
                            </div>
                            <div>
                                <div class="small text-muted">Last Edited</div>
                                <div class="small">{{ lastUserUpdatedAt(play) ? new Date(lastUserUpdatedAt(play)).toLocaleDateString() : '00/00/0000' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="d-flex align-items-start">
                            <div class="btn btn-white btn-icon-only-sm d-flex align-items-center justify-content-center me-2 disabled">
                                <img class="icon" src="/img/icons/avid-icons/calendar.svg" style="width: 16px; height: 16px;" alt="" />
                            </div>
                            <div>
                                <div class="small text-muted">Launch Date</div>
                                <div class="small">{{ play.start_date ? new Date(play.start_date).toLocaleDateString() : '00/00/0000' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="d-flex align-items-start">
                            <div class="d-flex align-items-center justify-content-center me-2 flex-shrink-0" style="width: 30px;">
                                <img v-if="lastUserUpdatedBy(play)" class="avatar rounded-circle cursor-pointer" :src="(lastUserUpdatedBy(play).image)" :alt="(lastUserUpdatedBy(play).first_name + ' ' + (lastUserUpdatedBy(play).last_name || '')).trim() || 'Last editor'" style="width: 30px; height: 30px; object-fit: cover;"/>
                                <i v-else class="fa fa-user text-muted" style="font-size: 16px;"></i>
                            </div>
                            <div class="min-w-0">
                                <div class="small text-muted">Last Editor</div>
                                <div class="small">{{ lastUserUpdatedBy(play) ? lastUserUpdatedBy(play).first_name + ' ' + (lastUserUpdatedBy(play).last_name || '') : 'N/A' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-card-footer">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="left-actions">
                        <button @click="goToPlayBuilder(play);" :class="status=='draft' ? 'btn-secondary' : 'btn-white'" class="btn btn-sm">
                            {{ status=='draft' ? 'Go To Play Builder' : 'Overview' }}
                        </button>
                    </div>
                    <div class="right-actions d-flex gap-2">
                        <button @click="openPlaybookDescription(play)" :class="status=='draft' ? 'btn-secondary' : 'btn-white'" class="btn btn-icon-only-sm btn-sm" 
                        data-bs-toggle="tooltip" title="Detailed view with extended insights and context">
                            <img src="/img/icons/avid-icons/deep-dive.svg" class="icon" alt="">
                        </button>
                        <button @click.stop="openMiniMenu(play)" :class="status=='draft' ? 'btn-secondary' : 'btn-white'" class="btn btn-icon-only-sm btn-sm" data-bs-toggle="tooltip" title="Actions">
                            <img src="/img/icons/avid-icons/mini-menu.svg" class="icon" alt="">
                        </button>
                    </div>
                </div>
            </div>

            <!-- Mini Menu Overlay (only show when this card's menu is open) -->
            <div v-if="miniMenuOpenFor === play.id" class="mini-menu-overlay" @click="closeMiniMenu">
                <div class="mini-menu" @click.stop>
                    <div class="mini-menu-header">
                        <span>Action Menu</span>
                        <button class="btn btn-icon-only-sm btn-white" @click="closeMiniMenu" data-bs-toggle="tooltip" title="Close">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="mini-menu-actions">
                        <button v-if="canEdit('playbooks')" class="mini-menu-item" @click="editPlay(play)">
                            <img class="icon me-2" src="/img/icons/avid-icons/pencil.svg" alt="">
                            <span>Edit Play</span>
                        </button>
                        <button v-else class="mini-menu-item" :disabled="true" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                            <img class="icon me-2" src="/img/icons/avid-icons/pencil.svg" alt="">
                            <span>Edit Play</span>
                        </button>
                        <button v-if="canEdit('playbooks')" class="mini-menu-item" @click="copyPlay(play)">
                            <img class="icon me-2" src="/img/icons/avid-icons/document-copy.svg" alt="">
                            <span>Copy Play</span>
                        </button>
                        <button v-else class="mini-menu-item" :disabled="true" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                            <img class="icon me-2" src="/img/icons/avid-icons/document-copy.svg" alt="">
                            <span>Copy Play</span>
                        </button>
                        <button v-if="canEdit('playbooks')" class="mini-menu-item delete" @click="deletePlay(play)">
                            <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">
                            <span>Delete Play</span>
                        </button>
                        <button v-else class="mini-menu-item delete" :disabled="true" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                            <img class="icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">
                            <span>Delete Play</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Playbook Description Modal -->
    <playbook-type-information-modal
        v-if="selectedPlaybook"
        :key="selectedPlaybook.id"
        :playbook_type="selectedPlaybook"
        :show="showPlaybookDescriptionModal"
        @update:show="showPlaybookDescriptionModal = $event"
    />
</template>

<script>
import permissionsMixin from '../../mixins/permissions';
import { usePlaybookStore } from '../../stores/playbook';
import { useClientStore } from '../../stores/client';
import { useNotifications } from '../../composables/useNotifications';
import { router } from '@inertiajs/vue3';

export default {
    name: 'PlayGridView',
    emits: ['copy-play', 'play-deleted'],
    props: {
        plays: {
            type: Array,
            required: true,
            default: () => []
        },
        status: {
            type: String,
            required: true,
            default: 'active'
        }

    },
    mixins: [permissionsMixin],
    data() {
        return {
            selectedPlaybook: null,
            showPlaybookDescriptionModal: false,
            miniMenuOpenFor: null
        };
    },
    setup() {
        const playbookStore = usePlaybookStore();
        const clientStore = useClientStore();
        const { showNotification } = useNotifications();
        return {
            playbookStore,
            clientStore,
            showNotification,
            router
        };
    },
    computed: {
        client() {
            return this.clientStore.getClient;
        }
    },
    methods: {
        /** Last user who edited (not system/jobs). Handles both snake_case and camelCase from backend. */
        lastUserUpdatedBy(play) {
            return play?.last_user_updated_by_user ?? play?.lastUserUpdatedByUser ?? null;
        },
        /** Date of last user edit; falls back to updated_at when not set. */
        lastUserUpdatedAt(play) {
            return play?.last_user_updated_at ?? play?.updated_at ?? null;
        },
        openPlaybookDescription(playbook) {
            // Pass the playbook_type from the play object, not the entire play object
            this.selectedPlaybook = playbook.playbook_type || playbook;
            this.showPlaybookDescriptionModal = true;
        },
        goToPlayBuilder(playbook) {
            // Navigate to play builder route
            router.visit(`/playbooks/${this.client.url}/builder/${playbook.url}/strategy`);
        },

        openMiniMenu(playbook) {
            if (this.miniMenuOpenFor === playbook.id) {
                this.miniMenuOpenFor = null;
            } else {
                this.miniMenuOpenFor = playbook.id;
            }
        },

        closeMiniMenu() {
            this.miniMenuOpenFor = null;
        },

        editPlay(playbook) {
            // Navigate to play builder
            router.visit(`/playbooks/${this.client.url}/builder/${playbook.url}/strategy`);
            this.closeMiniMenu();
        },

        copyPlay(playbook) {
            // Emit event to parent to handle the copy modal
            this.$emit('copy-play', playbook);
            this.closeMiniMenu();
        },

        deletePlay(playbook) {
            var self = this;

            Swal.fire({
                title: 'Delete Play',
                text: 'Are you sure you want to delete this play "' + playbook.name + '" ? This will remove the play and all associated assets from the system. This data cannot be restored.',
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                        popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/playbooks/'+self.client.url +'/'+ playbook.url);

                    // Remove from local plays array
                    const index = self.plays.findIndex(p => p.id === playbook.id);
                    if (index > -1) {
                        self.plays.splice(index, 1);
                    }

                    // Notify parent component about the deletion so it can refresh its data/pagination
                    self.$emit('play-deleted', playbook);

                    this.closeMiniMenu();

                    self.showNotification({
                        text: '<strong>' + playbook.name + '</strong> was deleted!'
                    });
                } else {
                    this.closeMiniMenu();
                }
            });
        }
    }
}
</script>
